import { render, staticRenderFns } from "./black-ips.vue?vue&type=template&id=4db3ec8e"
import script from "./black-ips.vue?vue&type=script&lang=js"
export * from "./black-ips.vue?vue&type=script&lang=js"
import style0 from "./black-ips.vue?vue&type=style&index=0&id=4db3ec8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports